import { AboutFour } from "../../components/About/AboutFour";
import { BannerThree } from "../../components/Banners/BannerThree";
import { BlogAreaThree } from "../../components/BlogAreas/BlogAreaThree";
import { BrandTwo } from "../../components/Brand/BrandTwo";
import { CounterAreaTwo } from "../../components/CounterAreas/CounterAreaTwo";
import { CtaAreaTwo } from "../../components/CtaAreas/CtaAreaTwo";
import { FeatureThree } from "../../components/Features/FeatureThree";
import { OverviewAreaTwo } from "../../components/OverviewAreas/OverviewAreaTwo";
import Industries from "../../components/Industries/industries";
import { ProjectAreaThree } from "../../components/ProjectAreas/ProjectAreaThree";
import { TeamAreaThree } from "../../components/TeamAreas/TeamAreaThree";
import { TestimonialAreaThree } from "../../components/TestimonialAreas/TestimonialAreaThree";
import { Layout } from "../../layouts/Layout";

const HomeTwo = () => {
  return (
    <Layout header={3} footer={2}>
      {/* banner-area */}
      <BannerThree />

      {/* brand-area */}
      <BrandTwo title={"We've rapidly grown to serve over 500 clients globally."} />

      {/* features-area */}
      <FeatureThree />

      {/* about-area */}
      <AboutFour />

      {/* overview-area */}
      <OverviewAreaTwo />

      {/*industries*/}
      <Industries />
      
      {/* project-area */}
     {/* <ProjectAreaThree />*/}

      {/* counter-area */}
    {/*  <CounterAreaTwo />*/}

      {/* team-area */}
   {/*   <TeamAreaThree /> */}

      {/* testimonial-area */}
      <TestimonialAreaThree />

      {/* cta-area */}
      <CtaAreaTwo />

      {/* blog-area */}
     {/* <BlogAreaThree />*/}
     <br/>
     <br/>
     <br/>
    </Layout>
  );
};

export default HomeTwo;
